import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithCompanyId } from 'src/redux/services/utils';

const appsTags = ['Apps'];
const companiesAdminTags = ['CompaniesAdmin', 'CompanyAdminDetail', 'CompanyFromAppKeySuperAdmin', 'CompanyFromEmailSuperAdmin'];
const usersAdminTags = ['UsersAdmin', 'UserAdminDetail'];
const customersTags = ['Customers', 'Customer', 'CustomerExplain', 'Resolutions'];
const analyticsTags = ['PeriodOverview', 'Alerts', 'ScoreClusterAggregate'];
const creditsTags = ['AvailableBudget', 'CreditsOverview', 'CreditsReporsAsCost', 'Purchase'];
const plansTags = ['Plans'];
const notificationsTags = ['NotificationsStatus'];
const exportTags = ['Exports', 'Analytics'];
const importsTags = ['Imports'];
const identitiesTags = ['Identity'];

const tagTypes = [
  ...appsTags,
  ...companiesAdminTags,
  ...usersAdminTags,
  ...customersTags,
  ...analyticsTags,
  ...creditsTags,
  ...plansTags,
  ...notificationsTags,
  ...exportTags,
  ...importsTags,
  ...identitiesTags,
];

export const baseApiWithCompanyId = createApi({
  baseQuery: baseQueryWithCompanyId,
  tagTypes,
  endpoints: (builder) => ({
    __placeholder: builder.query<null, void>({
      query: () => '',
    }),
  }),
});
